import { useEffect } from 'react';

// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details } from '@return-rabbit/nexus';

import { OrderDetailsSelectedContent } from '../../selected-content/order-details-selected-content';
import { PendingReturnHeader } from '../sections/pending-return-header';
import { PendingReturnInfo } from '../sections/pending-return-info';
import { ShipmentConfigurator } from '../sections/shipment-configurator';
import { ReturnRateCard } from '../sections/return-rate-card';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';
import { useReturnConfig } from '../return-config-provider';

export const ConfirmReturn = () => {
  const { isRating, totalCost } = useFulfillmentPlannerContext();
  const { isShippingFeeWaived } = useReturnConfig();
  const { saveShippingCost } = Details.useShippingInfo();
  const { isReturnCreatedInAdvancedMode } = Details.useReturnMode();

  const shouldSaveShippingCost = isReturnCreatedInAdvancedMode && !isRating && !isShippingFeeWaived;

  useEffect(() => {
    if (shouldSaveShippingCost) {
      saveShippingCost({
        amount: totalCost?.value,
        currency: totalCost?.code,
      });
    }
  }, [shouldSaveShippingCost, totalCost, saveShippingCost]);

  return (
    <OrderDetailsSelectedContent
      fulfillmentPlannerSections={<ShipmentConfigurator />}
      headerContent={<PendingReturnHeader />}
      primaryShipmentSections={<PendingReturnInfo />}
      rateCard={<ReturnRateCard />}
      secondaryShipmentSections={null}
    />
  );
};
